// temporary controller for popover functionality
// must be merged and replaced by main 'PopoverController' during refactoring in LEGH-5331

import { Controller } from '@hotwired/stimulus'
import { createPopper, Instance } from '@popperjs/core'

export default class extends Controller {
  static targets = ['trigger', 'content']

  declare readonly triggerTarget: HTMLElement
  declare readonly contentTarget: HTMLElement
  declare popperInstance: Instance | null

  connect (): void {
    document.addEventListener('scroll', () => this.hide())
    document.addEventListener('click', this.handleClickOutside.bind(this))
  }

  disconnect (): void {
    document.removeEventListener('scroll', () => this.hide())
    document.removeEventListener('click', this.handleClickOutside.bind(this))
  }

  show (): void {
    this.contentTarget.classList.remove('hidden')

    this.popperInstance = createPopper(this.triggerTarget, this.contentTarget, {
      placement: 'bottom',
      modifiers: [
        {
          name: 'flip',
          options: {
            fallbackPlacements: ['top', 'right', 'left']
          }
        },
        {
          name: 'preventOverflow',
          options: {
            boundary: 'viewport'
          }
        },
        {
          name: 'offset',
          options: {
            offset: [0, 2]
          }
        }
      ]
    })
  }

  hide (): void {
    this.contentTarget.classList.add('hidden')

    if (this.popperInstance != null) {
      this.popperInstance.destroy()
      this.popperInstance = null
    }
  }

  handleClickOutside (event: Event): void {
    const popover = event.target as HTMLElement

    if (!this.element.contains(popover)) this.hide()
  }
}
